// import React from 'react'
// import { colorPrimary } from '../../../utils/utils';
// import {SearchOutlined} from '@ant-design/icons'
// import { Button, Input, Space } from 'antd';
// const PropsSearchTable = ({key,name,setTextValue,textValue,setSearchText,searchInputMobile,searchInput,handleSearch,handleReset,t}) => ({
//     filterIcon: () => <SearchOutlined color={colorPrimary} />,
//     filterDropdown: ({
//       setSelectedKeys,
//       selectedKeys,
//       confirm,
//       clearFilters,
//     }) => (
//       <div
//         style={{
//           padding: 8,
//         }}
//         onKeyDown={(e) => e.stopPropagation()}
//       >
//         <Input
//           ref={searchInputMobile}
//           placeholder={name}
//           value={textValue}
//           onChange={(e) => {
//             setSelectedKeys(e.target.value ? [e.target.value] : []);
//             setTextValue(e.target.value);
//           }}
//           onPressEnter={() =>{
//             console.log(selectedKeys, confirm, key);
//             handleSearch(selectedKeys, confirm, key)}
//           }
//           style={{
//             marginBottom: 8,
//             display: 'block',
//           }}
//         />
//         <Space>
//           <Button
//             type="primary"
//             onClick={() => {
//               console.log(selectedKeys, confirm, key);
//               handleSearch(selectedKeys, confirm, key)
//             }}
//             icon={<SearchOutlined />}
//             size="small"
//             style={{
//               width: 90,
//             }}
//           >
//             {t.Search}
//           </Button>
//           <Button
//             onClick={() => clearFilters && handleReset(clearFilters, confirm)}
//             size="small"
//             style={{
//               width: 90,
//             }}
//           >
//             {t.Reset}
//           </Button>
//         </Space>
//       </div>
//     ),
//     onFilterDropdownOpenChange: (visible) => {
//       if (visible) {
//         setTextValue('');
//         setSearchText({ value: '', key: '' });
//         setTimeout(() => searchInput.current?.select(), 100);
//       }
//     },
//   })

import { Button, Input, Space } from "antd";
import { colorPrimary } from "../../../utils/utils";
import {SearchOutlined} from '@ant-design/icons'
  // export default PropsSearchTable


const PropsSearchTable = ({
  key,
  name,
  setTextValue,
  textValue,
  setSearchText,
  searchInputMobile,
  searchInput,
  handleSearch,
  handleReset,
  t,
}) => ({
  filterIcon: () => <SearchOutlined style={{ color: colorPrimary }} />,
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        ref={searchInputMobile}
        placeholder={name}
        value={textValue}
        onChange={(e) => {
          setSelectedKeys(e.target.value ? [e.target.value] : []);
          setTextValue(e.target.value);
        }}
        onPressEnter={() => handleSearch(selectedKeys, confirm, key)}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, key)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          {t.Search}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          {t.Reset}
        </Button>
      </Space>
    </div>
  ),
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => searchInput.current?.select(), 100);
      setTextValue('');
      setSearchText({ value: '', key: '' });
    }
  },
});


export default PropsSearchTable